export const setUsername = "SET_USERNAME";
export const setToken = "SET_TOKEN";
export const setIsLogin = "SET_IS_LOGIN";
export const setInitialState = "SET_INITIAL_STATE";
export const setName = "SET_NAME";
export const setRole = "SET_ROLE";
export const setProfilePicure = "SET_PROFILE_PICTURE";

export const setWindowWidth = "SET_WINDOW_WIDTH";
export const setIsBlur = "SET_IS_BLUR";
